import React from 'react';
import { BaseFilterRadioSelect } from 'src/components/sidebar-filters/base/BaseFilterRadioSelect';
import { IBillSidebarFilters } from '../../customer-utility-bill/sidebar/billSidebarFilters';

const VERIFICATION_OPTIONS: { value: 'verified' | 'unverified'; label: string }[] = [
    { value: 'verified', label: 'Verified' },
    { value: 'unverified', label: 'Not verified' },
];

interface IBillVerificationFilterSelectProps {
    value: IBillSidebarFilters['verification'];
    onChange: (value: IBillSidebarFilters['verification']) => void;
    label?: string;
}

export const BillVerificationFilterSelect: React.FC<IBillVerificationFilterSelectProps> = ({ value, onChange, label = 'Verification' }) => {
    return (
        <BaseFilterRadioSelect
            label={label}
            resizable={false}
            showClear={false}
            selectedCountInLabel
            options={VERIFICATION_OPTIONS}
            value={value}
            onChange={v => onChange(v as IBillSidebarFilters['verification'])}
            height={80}
        />
    );
};
